import { Link, useNavigate } from "react-router-dom";
import { LANDING } from "@/constants/testIds";

export const Navbar = () => {
  const navigate = useNavigate();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#fbfcfe]/80 border-b border-[#dce6f0]">
      <nav className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid={LANDING.navHome}
          className="font-heading text-xl font-semibold tracking-tight text-[#2a3b5c] flex items-center gap-2"
        >
          <span className="w-7 h-7 rounded-full bg-[#ffe89a] inline-flex items-center justify-center text-[#2a3b5c] text-sm font-semibold">
            K
          </span>
          Kenisha&#39;s&nbsp;Tutoring
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm text-[#5c6b85]">
          <button
            data-testid={LANDING.navSubjects}
            onClick={() => scrollTo("subjects")}
            className="hover:text-[#3d6fa8] transition-colors"
          >
            Subjects
          </button>
          <button
            data-testid={LANDING.navAbout}
            onClick={() => scrollTo("about")}
            className="hover:text-[#3d6fa8] transition-colors"
          >
            About
          </button>
          <button
            data-testid={LANDING.navPricing}
            onClick={() => scrollTo("pricing")}
            className="hover:text-[#3d6fa8] transition-colors"
          >
            Pricing
          </button>
          <button
            data-testid="landing-nav-resources"
            onClick={() => scrollTo("resources")}
            className="hover:text-[#3d6fa8] transition-colors"
          >
            Resources
          </button>
        </div>

        <button
          data-testid={LANDING.navBook}
          onClick={() => navigate("/book")}
          className="rounded-full px-5 py-2 text-sm font-medium bg-[#8ab8e8] text-[#2a3b5c] hover:bg-[#6fa1d6] active:scale-95 transition-all duration-300"
        >
          Book a Session
        </button>
      </nav>
    </header>
  );
};

export default Navbar;
